import styled from 'styled-components';

export const Container = styled.section`
  position: absolute;
  flex-direction: column;
  top: 36px;
  left: 805px;
  display: flex;
  width: 381px;
  height: calc(100vh - 138px);
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: 8px;

  @media (max-width: 1200px) {
    display: none;
  }
`;

export const SummaryHeader = styled.section`
  display: flex;
  align-items: center;
  width: 100%;
  height: 72px;
  gap: 10px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.border};
  padding: 7px 0;

  img {
    padding-left: 20px;
    width: 48px;
    height: 48px;
  }

  h1 {
    font-family: 'Elza', sans-serif;
    font-size: 20px;
    font-weight: 700;
    line-height: 24.2px;
    letter-spacing: 0.016em;
    text-align: left;
    color: ${({ theme }) => theme.colors.text};
  }
`;

export const Detailing = styled.section`
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: start;
  width: 100%;
  flex: 1;
  border-bottom: 1px solid ${({ theme }) => theme.colors.border};
  background-color: ${({ theme }) => theme.colors.surface.base};
`;

export const SelectedTickets = styled.section`
  width: 100%;
  flex: 1;
  max-height: calc(100vh - 400px);
  padding: 16px 24px 16px 24px;
  overflow-y: scroll;
  overflow-x: hidden;
`;

export const TicketItem = styled.div`
  display: grid;
  grid-template-columns: auto 1fr auto;
  gap: 12px;
  align-items: start;
`;

export const TicketQuantity = styled.span`
  font-family: 'Elza', sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  color: ${({ theme }) => theme.colors.text.primary};
`;

export const TicketDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const TicketName = styled.span`
  font-family: 'Elza', sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  color: ${({ theme }) => theme.colors.text.primary};
`;

export const TicketCategory = styled.span`
  font-family: 'Elza', sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  color: ${({ theme }) => theme.colors.text.secondary};
`;

export const TicketPrice = styled.span`
  font-family: 'Elza', sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  color: ${({ theme }) => theme.colors.text.primary};
`;

export const TicketDate = styled.span`
  font-family: 'Elza', sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  color: ${({ theme }) => theme.colors.text.secondary};
`;

export const TicketTotalPrice = styled.span`
  font-family: 'Elza', sans-serif;
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
  color: ${({ theme }) => theme.colors.text.primary};
  text-align: right;
`;

export const SummaryFooter = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 182px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.border};
  background-color: ${({ theme }) => theme.colors.surface.high};
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  gap: 16px;
`;

export const RowFullWidth = styled.section<{
  $align: 'center' | 'space-between';
}>`
  display: flex;
  justify-content: ${({ $align }) => $align};
  width: 333px;
`;

export const TextInfo = styled.span<{ $weight: number; size: number }>`
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'Elza', sans-serif;
  font-size: ${({ size }) => size}px;
  font-weight: ${({ $weight }) => $weight};
  line-height: 19.36px;
  text-align: center;
  gap: 4px;
`;

export { StrikethroughPrice, PriceSkeleton } from '../Resale/sharedStyles';
